import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15074a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "person-picker-grid"
}
const _hoisted_2 = {
  key: 3,
  class: "text-center text-bold q-pa-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_PersonAvatarItem = _resolveComponent("PersonAvatarItem")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_q_linear_progress, {
          key: 0,
          color: "primary",
          indeterminate: ""
        }))
      : _createCommentVNode("", true),
    (_ctx.mode === 'single')
      ? (_openBlock(), _createBlock(_component_q_list, {
          key: 1,
          bordered: "",
          separator: "",
          class: "rounded-borders",
          style: {"max-height":"300px","overflow-y":"auto"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persons, (person) => {
              return (_openBlock(), _createBlock(_component_q_item, {
                key: person.id,
                clickable: "",
                active: _ctx.modelValue.includes(person.id),
                onClick: ($event: any) => (_ctx.$emit('update:modelValue', [person.id]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, {
                        size: "40px",
                        color: "grey-3",
                        "text-color": "grey-6"
                      }, {
                        default: _withCtx(() => [
                          (person.primaryFace && person.primaryFace.imageUrl)
                            ? (_openBlock(), _createBlock(_component_q_img, {
                                key: 0,
                                src: person.primaryFace.imageUrl,
                                fit: "cover",
                                class: _normalizeClass({ 'grayscale': _ctx.modelValue.includes(person.id) })
                              }, null, 8, ["src", "class"]))
                            : (_openBlock(), _createBlock(_component_q_icon, {
                                key: 1,
                                name: "fa fa-user"
                              }))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(person.label || 'Unnamed Person'), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_label, { caption: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(person.faceCount || 0) + " faces", 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_radio, {
                        "model-value": _ctx.modelValue[0],
                        val: person.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', [$event])))
                      }, null, 8, ["model-value", "val"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["active", "onClick"]))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persons, (person) => {
            return (_openBlock(), _createBlock(_component_PersonAvatarItem, {
              key: person.id,
              person: person,
              selected: _ctx.isSelected(person.id),
              size: "88px",
              onClick: ($event: any) => (_ctx.toggleMulti(person.id))
            }, null, 8, ["person", "selected", "onClick"]))
          }), 128))
        ])),
    _createVNode(_component_InfiniteScroll, {
      active: _ctx.hasMore,
      loading: _ctx.loadingMore,
      class: "q-mt-xs",
      onLoadMore: _ctx.loadMore
    }, null, 8, ["active", "loading", "onLoadMore"]),
    (!_ctx.loading && _ctx.persons.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.emptyLabel), 1))
      : _createCommentVNode("", true)
  ]))
}